module.exports = __webpack_public_path__ + "static/media/banner3.59b7c2f4.jpg";